export const LogEvents = {
    PARTICIPANT_CREATION_SUCCESS: 'lumos_participant_creation_success',
    PARTICIPANT_CREATION_ERROR: 'lumos_participant_creation_error',
    TRAINING_CERTIFICATE_WITH_NULL_COMPLETED_ON: 'lumos_training_certificate_with_null_completed_on',
    PARTICIPANT_RESPONSES_FETCHED: 'lumos_participant_responses_fetched',
    PARTICIPANT_RESPONSES_TAB_LOADED: 'lumos_participant_responses_tab_loaded',
};
